import moment from 'moment';
import React, { useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import axios from 'axios';
import waterFlowIcon from '../../../../assets/icons/water-flow-icon.png';
import { BASE_URL } from '../../../../services/api';
import AuthService from '../../../../services/auth';
import SelectDataButton from '../../date-selector';
import ErrorMessage from '../../messages-panel/error-message';

export default function SumWaterFlowDataAnimalPanel({ sensors }) {
	let { access_token } = AuthService.getCurrentUser();
	// data inicial e final para o intervalo de dados do valor acumulado
	const [periodo1Acc, setPeriodo1Acc] = useState(() => moment().startOf('day').toDate());
	const [periodo2Acc, setPeriodo2Acc] = useState('');
	const [waterFlowAccValue, setWaterFlowAccValue] = useState(NaN); // Para o painel de valor acumulado

	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);
	// IDs estáveis evitam refazer consultas quando o componente pai renderiza.
	const sensorIds = JSON.stringify([...new Set(sensors.map((sensor) => sensor.id_dispositivo))]);

	useEffect(() => {
		let active = true;
		let fetching = false;
		const fetchTotal = async () => {
			if (fetching) return;
			fetching = true;
			setLoading(true);
			setError(false);
			const data1 = moment(periodo1Acc).utc().format('YYYY-MM-DDTHH:mm');
			const endFilter = periodo2Acc
				? `&data:<=${moment(periodo2Acc).utc().format('YYYY-MM-DDTHH:mm')}`
				: '';
			try {
				const responses = await Promise.all(JSON.parse(sensorIds).map((sensorId) =>
					axios.get(`${BASE_URL}/consulta_poco?tipo_mensagem=1&sensor=${sensorId}&data:>=${data1}${endFilter}`, {
						headers: { Authorization: `Bearer ${access_token}` },
					})
				));
				const values = responses.map(({ data }) => {
					const value = data?.valor_acumulado;
					return typeof value === 'number' || (typeof value === 'string' && value.trim() !== '')
						? Number(value) : NaN;
				});
				// Só mostra o total quando todos os poços têm um acumulado válido.
				if (active) setWaterFlowAccValue(values.length > 0 && values.every(Number.isFinite)
					? values.reduce((total, value) => total + value, 0) : NaN);
			} catch {
				if (active) {
					setError(true);
					setWaterFlowAccValue(NaN);
				}
			} finally {
				fetching = false;
				if (active) setLoading(false);
			}
		};
		fetchTotal();
		const intervalId = setInterval(() => {
			if (!document.hidden) fetchTotal();
		}, 5 * 60 * 1000);
		return () => {
			active = false;
			clearInterval(intervalId);
		};
	}, [sensorIds, access_token, periodo1Acc, periodo2Acc]);

	return (
		<div className="little-panel-container">
			<div className="panel-title-container">
				<em className="panel-title">Dados Somados dos Poços</em>
			</div>
			{loading ? (
				<div className="panel-loading">
					<ReactLoading
						type="spinningBubbles"
						color="var(--main-color)"
						width="50px"
						height="50px"
					/>
				</div>
			) : error ? (
				<ErrorMessage />
			) : (
				<div style={{ margin: '10px' }}>
					<SelectDataButton
						periodo1={periodo1Acc}
						setPeriodo1={setPeriodo1Acc}
						periodo2={periodo2Acc}
						setPeriodo2={setPeriodo2Acc}
						hourlyData={true}
					/>
					<div className="last-data-container">
						<div className="last-data-content-container">
							<img
								src={waterFlowIcon}
								height={'40px'}
								width={'40px'}
								alt="water-flux-icon"
								style={{ marginRight: '5px' }}
							/>

							{!isNaN(waterFlowAccValue) ? (
								<p className="last-value-text">{waterFlowAccValue.toFixed(1)} m³</p>
							) : (
								<p className="last-value-text">-- m³</p>
							)}
						</div>
					</div>
				</div>
			)}
		</div>
	);
}
